module.exports = __webpack_public_path__ + "static/media/20ECE11.20a2f441.jpg";